/* @generated */
import * as React from "react";
import { Item as Item$1 } from "../split/item.esm.js";
const Item = ({ children, ...rest }) => {
  return /* @__PURE__ */ React.createElement(Item$1, { ...rest }, children);
};
export {
  Item
};
